import { Component } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { NzI18nService, en_US, zh_CN, ja_JP } from 'ng-zorro-antd/i18n';
import * as moment from 'moment';
import 'moment/locale/zh-cn';
import 'moment/locale/ja';
import 'moment/locale/en-nz';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    public translate:TranslateService,
    private i18n: NzI18nService
    ){
      
  }

  ngOnInit(): void {
    // this.translate.use('zh');
    // this.i18n.setLocale(zh_CN);
    var langs = JSON.parse(localStorage.getItem('langs'))
    if(!langs) {
      this.translate.use('jp');
      this.i18n.setLocale(ja_JP);
    }else {
      this.translate.use(langs.lang);
      this.i18n.setLocale(langs.locale);
      moment.locale(langs.momentLanguage);
    }
    

  }
}
